import React, { useRef, useEffect } from 'react';

const CollectionTabs = ({ 
  activeCollectionType, 
  setActiveCollectionType,
  animeTotalCount,
  mangaTotalCount,
  charactersTotalCount
}) => {
  const tabsRef = useRef(null);
  const activeTabRef = useRef(null);
  
  useEffect(() => {
    if (activeTabRef.current && tabsRef.current && window.innerWidth <= 768) {
      const container = tabsRef.current;
      const activeTab = activeTabRef.current;
      const scrollLeft = activeTab.offsetLeft - (container.clientWidth / 2) + (activeTab.clientWidth / 2);
      container.scrollTo({
        left: Math.max(0, scrollLeft),
        behavior: 'smooth'
      });
    }
  }, [activeCollectionType]);

  return (
    <div ref={tabsRef} className="collection-tabs">
      <button
        ref={activeCollectionType === 'anime' ? activeTabRef : null}
        onClick={() => setActiveCollectionType('anime')}
        className={`collection-tab ${activeCollectionType === 'anime' ? 'active' : ''}`}
      >
        <span>Anime</span>
        <span className="collection-count">{animeTotalCount}</span>
      </button>
      
      <button
        ref={activeCollectionType === 'manga' ? activeTabRef : null}
        onClick={() => setActiveCollectionType('manga')}
        className={`collection-tab ${activeCollectionType === 'manga' ? 'active' : ''}`}
      >
        <span>Manga</span>
        <span className="collection-count">{mangaTotalCount}</span>
      </button>
      
      <button
        ref={activeCollectionType === 'characters' ? activeTabRef : null}
        onClick={() => setActiveCollectionType('characters')}
        className={`collection-tab ${activeCollectionType === 'characters' ? 'active' : ''}`}
      >
        <span>Characters</span>
        <span className="collection-count">{charactersTotalCount}</span>
      </button>
    </div>
  );
};

export default CollectionTabs;